<!-- backend/src/components/Cards/CardUserSettings.svelte -->

<script>
  import { onMount } from 'svelte';
  import { roleList, userAdd, userUpdate, rolesUserRoles } from '../../Api.svelte';
  import { usersStore, selectedUser, isEditing } from '../../stores/stores.js';
  import Switch from "svelte-switch";

  let roles = [];
  let selectedRoles = new Set();
  let username = '';
  let tel = '';
  let first_name = '';
  let last_name = '';
  let _id = null; 
  let editing = false;
  let checkedValue = true;
  let userRolesMap = {};


  function handleChange(e) {
    const { checked } = e.detail;
    checkedValue = checked;
  }

  async function loadUserRoles(user) {
  const roleNames = await rolesUserRoles(user._id); // ['SUPER_ADMIN']
  const roles = await roleList(); // Tüm roller

  // roleNames'e göre rollerin ID'lerini seç
  const selectedRoleIds = roles
    .filter(role => roleNames.includes(role.role_name)) // role_name'e göre filtrele
    .map(role => role._id); // ID'leri al

  return new Set(selectedRoleIds); // ID'leri bir Set olarak döndür
}

// Store'lara doğrudan abone ol
selectedUser.subscribe(async (user) => {
  if (user) {
    _id = user._id;
    username = user.uname;
    tel = user.phone_number;
    first_name = user.first_name;
    last_name = user.last_name;
    checkedValue = true;

    // Kullanıcının rollerini yükle ve selectedRoles'i güncelle
    selectedRoles = await loadUserRoles(user);
  }
});

  isEditing.subscribe(value => {
    editing = value;
  });

  async function submitForm() {
    if (editing) {
      await updateUser();
    } else {
      await addUser();
    }
  }

  async function addUser() {
    const selectedRolesArray = Array.from(selectedRoles);
    const result = await userAdd(username, tel, first_name, last_name, selectedRolesArray);
    if (result) {
      usersStore.set(result);
      resetForm();
    } else {
      console.error('Kullanıcı ekleme başarısız.');
    }
  }

  async function updateUser() {
    const selectedRolesArray = Array.from(selectedRoles);
    const result = await userUpdate(_id, tel, first_name, last_name, checkedValue, selectedRolesArray);
    if (result) {
      usersStore.set(result);
      isEditing.set(false); // Düzenleme modu kapatılır
      resetForm();
    } else {
      console.error('Kullanıcı güncelleme başarısız.');
    }
  }

  function resetForm() {
    _id = null;
    username = '';
    tel = '';
    first_name = '';
    last_name = '';
    selectedRoles = new Set();
  }

  onMount(async () => {
    roles = await roleList();
  });

  function toggleRoleSelection(roleId) {
  if (selectedRoles.has(roleId)) {
    selectedRoles.delete(roleId);
  } else {
    selectedRoles.add(roleId);
  }
  selectedRoles = new Set([...selectedRoles]); // Reaktif hale getirmek için yeni bir set oluşturun
}
</script>
<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
  <div class="rounded-t bg-white mb-0 px-6 py-4">
    <div class="text-center flex justify-between">
      <h6 class="text-blueGray-700 text-xl font-bold">Kullanıcı Bilgileri</h6>
      <button class="{editing ? 'bg-lightBlue-400' : 'bg-red-400'} text-white active:{editing ? 'bg-lightBlue-500' : 'bg-red-500'} font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click="{submitForm}">
        {editing ? 'Düzenle' : 'Kaydet'}
      </button>
    </div>
  </div>

  <div class="flex-auto px-4 lg:px-10 py-8 pt-0">
    <form on:submit|preventDefault="{submitForm}">
      <div class="flex mt-4 flex-wrap">
        <!-- Kullanıcı Adı Alanı -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="username">
              Kullanıcı Adı
            </label>
            <input id="username" type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" bind:value="{username}" />
          </div>
        </div>
        <!-- Telefon Numarası Alanı -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="tel">
              Telefon Numarası
            </label>
            <input id="tel" type="tel" placeholder="5?????????" required class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" bind:value="{tel}" />
          </div>
        </div>
        <!-- Adı Alanı -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="first_name">
              Adı
            </label>
            <input id="first_name" type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" bind:value="{first_name}" />
          </div>
        </div>
        <!-- Soyadı Alanı -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="last_name">
              Soyadı
            </label>
            <input id="last_name" type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" bind:value="{last_name}" />
          </div>
        </div>
        <!-- Aktif/pasif -->
        {#if editing}
        <div class="w-full lg:w-full px-4 place-content-center">
          <div class="place-items-center">
            <span>Aktif Pasif Durumu</span>
            <Switch on:change={handleChange} checked={checkedValue} />
            Seçiminiz: {checkedValue ? "Aktif" : "Pasif"}
          </div>
        </div>
        {/if}
        <br/>
        <br/>
        <!-- Roller -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Roller
            </div>
            <div class="flex flex-wrap">
              {#each roles as role}
                {#if !selectedRoles.has(role._id)}
                  <button type="button" class="border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-white text-blueGray-600" on:click="{() => toggleRoleSelection(role._id)}">
                    {role.role_name}
                  </button>
                {/if}
              {/each}
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Seçilen Roller
            </div>
            <div class="flex flex-wrap">
              {#each roles as role}
                {#if selectedRoles.has(role._id)}
                  <button type="button" class="border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-emerald-500 text-white" on:click="{() => toggleRoleSelection(role._id)}">
                    {role.role_name}
                  </button>
                {/if}
              {/each}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
